import { restClient } from '@/Core'

import { toNodeShares } from '../Helpers/diskResponse'

import type { DiskNodeShares } from '../Contracts/DiskShare'

/** «Хто має доступ»: `GET /services/disk/nodes/{uuid}/shares` — три групи й моя роль. */
export const LoadDiskNodeSharesTask = async (uuid: string): Promise<DiskNodeShares> => {
    const response = (await restClient.get(
        `/services/disk/nodes/${encodeURIComponent(uuid)}/shares`,
        {},
        { forceRefresh: true }
    )) as unknown

    return toNodeShares(response)
}
